"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownArrow = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const DownArrow = ({
  size = 16,
  width = size,
  height = size,
  fill = '#121213',
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: fill
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.08953 4.96967C2.79664 4.67678 2.32177 4.67678 2.02887 4.96967C1.73598 5.26256 1.73598 5.73744 2.02887 6.03033L3.08953 4.96967ZM7.52884 11.5303C7.82173 11.8232 8.2966 11.8232 8.5895 11.5303C8.88239 11.2374 8.88239 10.7625 8.5895 10.4696L7.52884 11.5303ZM2.02887 6.03033L7.52884 11.5303L8.5895 10.4696L3.08953 4.96967L2.02887 6.03033Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.0303 6.08905C14.3232 5.79616 14.3232 5.32129 14.0303 5.02839C13.7374 4.73549 13.2626 4.73549 12.9697 5.02838L14.0303 6.08905ZM7.52804 10.4699C7.23514 10.7628 7.23514 11.2377 7.52803 11.5306C7.82092 11.8235 8.29579 11.8235 8.58869 11.5306L7.52804 10.4699ZM12.9697 5.02838L7.52804 10.4699L8.58869 11.5306L14.0303 6.08905L12.9697 5.02838Z"
}));

exports.DownArrow = DownArrow;